module.exports = __webpack_public_path__ + "media/images/backdrop-b9aee6c9.jpg";